import { render, staticRenderFns } from "./IconSbjbx.vue?vue&type=template&id=46995be4"
import script from "./IconSbjbx.vue?vue&type=script&lang=js"
export * from "./IconSbjbx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports